import React from 'react';

// The red Do Not Serve marker. The reason, when this user may see it, is on
// hover; the server sends a null reason to drivers and crew leads.
function DoNotServeBadge({ reason, inherited = false, style }) {
  const title = [
    inherited ? 'Inherited from the parent customer.' : null,
    reason ? `Reason: ${reason}` : null,
  ].filter(Boolean).join(' ');

  return (
    <span
      className="do-not-serve-badge"
      title={title || undefined}
      style={{
        display: 'inline-block',
        marginLeft: '6px',
        padding: '1px 7px',
        borderRadius: '10px',
        fontSize: '11px',
        fontWeight: 600,
        lineHeight: '16px',
        color: '#fff',
        backgroundColor: '#c62828',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        ...style,
      }}
    >
      Do Not Serve
    </span>
  );
}

export default DoNotServeBadge;
